module.exports = __webpack_public_path__ + "static/media/directions.9f3eb45f.svg";